module.exports = __webpack_public_path__ + "img/ic-tooltip.54e8e312.svg";